// extracted by mini-css-extract-plugin
export default {"error-page":"ErrorPage_error-page__ysdaT","error-page__title":"ErrorPage_error-page__title__WGsBV","error-page__subtitle":"ErrorPage_error-page__subtitle__sgkrk"};